module.exports = __webpack_public_path__ + "static/media/thinking.5226418a.svg";